import {validateHandler} from "./validator.js";


const albumConfig = {
    name: {
        required: true,
        minLength: 1,
    },
    nameEn: {
        required: true,
        english: true,
    },
    albumType: {
        required: true,
    },
    desc: {
        required: true,
    },
    registerType: {
        required: true,
    },
    initBalanceAmount: {
        number: true,
    },
    bespokRate: {
        number: true,
    }
}

export default async function validate(data, options) {
    return await validateHandler(albumConfig, data, {...options,
        customValidator: async (data, error) => {
            if (data.name === "test") {
                error.name = "test is not allowed";
            }
    }});
}